import * as Yup from 'yup'

const editReservationValidator = Yup.object ({
  professional: Yup
    .object ()
    .nullable ()
    .required ('Selecione um profissional'),

  description: Yup
    .string ()
    .required ('Insira uma descrição')
    .max (128, 'A descrição deve ter até 128 caracteres'),

  startDate: Yup
    .string ()
    .required ('Selecione uma data de início'),

  endDate: Yup
    .string ()
    .required ('Selecione uma data final'),
  
  period: Yup
    .object ()
    .nullable ()
    .required ('Selecione um período'),

  startTime: Yup
    .object ()
    .nullable ()
    .required ('Selecione o horário inicial'),

  endTime: Yup
    .object ()
    .nullable ()
    .required ('Selecione o horário final'),
})

export default editReservationValidator
